import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=bb264e24&scoped=true"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"
import style0 from "./color-picker.vue?vue&type=style&index=0&id=bb264e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb264e24",
  null
  
)

export default component.exports